export const getUpdateAppointmentUrl = ({
  appointmentId,
}: {
  appointmentId: number;
}) => `appointments/${appointmentId}`;
